module.exports = __webpack_public_path__ + "static/media/moto-card.4ce205da.png";